import { Course } from '@models/course.model';
import { CourseProgressStatus } from '@pipes/course-progress-status/course-progress-status.pipe';

/** The completion statuses the course lists start with: every course not finished yet. */
export const DEFAULT_COURSE_STATUSES: CourseProgressStatus[] = [
  CourseProgressStatus.new,
  CourseProgressStatus.running,
  CourseProgressStatus.inReview,
];

const DEFAULT_COURSE_STATUSES_BEFORE_IN_REVIEW: CourseProgressStatus[] = [
  CourseProgressStatus.new,
  CourseProgressStatus.running,
];

export class CourseFilterHelper {
  /**
   * Filters saved before In review was a status of its own hold the old default (New and
   * Running), which used to include the courses in review. They get In review added, so those
   * courses do not disappear; any other saved selection is kept as it is.
   */
  static withInReview(
    statuses: CourseProgressStatus[],
  ): CourseProgressStatus[] {
    const isOldDefault =
      statuses.length === DEFAULT_COURSE_STATUSES_BEFORE_IN_REVIEW.length &&
      DEFAULT_COURSE_STATUSES_BEFORE_IN_REVIEW.every(status =>
        statuses.includes(status),
      );
    return isOldDefault ? [...DEFAULT_COURSE_STATUSES] : statuses;
  }

  static filterByStatus(
    courses: Course[],
    status: CourseProgressStatus,
  ): Course[] {
    switch (status) {
      case CourseProgressStatus.finished:
        return courses.filter(x => x?.courseResult?.progress === 100);
      case CourseProgressStatus.new:
        return courses.filter(
          x =>
            !x?.courseResult ||
            (!x.courseResult.progress && !x.courseResult.inReview),
        );
      case CourseProgressStatus.running:
        return courses.filter(
          x =>
            x?.courseResult &&
            !x.courseResult.inReview &&
            x.courseResult.progress > 0 &&
            x.courseResult.progress < 100,
        );
      case CourseProgressStatus.inReview:
        return courses.filter(x => !!x?.courseResult?.inReview);
    }
    return [];
  }

  static filterByStatuses(
    courses: Course[],
    statuses: CourseProgressStatus[],
  ): Course[] {
    const reducer = (accumulator: Course[], status: CourseProgressStatus) =>
      accumulator.concat(this.filterByStatus(courses, status));

    return statuses.reduce(reducer, []);
  }
}
